export const MuiSvgIcon = () => ({
    styleOverrides: {
        fontSizeSmall: {
            fontSize: '16px'
        },
        root: {
            fontSize: '24px'
        },
        fontSizeLarge: {
            fontSize: '32px'
        }
    }
});
